import apiProxy from './api-proxy-inst';

class ProductApi {
  ErpProductList(args) {
    return apiProxy.requestPublic('/erpapp_on_shelf_product/list', args).then(data => {
      return data;
    });
  }
}

export default new ProductApi();